<template>
  <div class="teacher-detail">
    <div class="info-box">
      <img :src="teacherData.avatar" />
      <div class="info-box-left">
        <p class="teacher-name">
          {{teacherData.real_name}}
          <span class="teacher-level" v-if="teacherData.level">【{{teacherData.level}}】</span>
        </p>
        <p class="teacher-introduction">简介：{{teacherData.introduction}}</p>
      </div>
    </div>
    <Tabs class="tabs" value="course">
      <TabPane label="课程" name="course">
        <CourseList :teacherID="teacherID"></CourseList>
      </TabPane>
      <TabPane v-if="teacherData.level" label="约课课表" name="course-schedule">
        <TeachOtoScheduleDetail :teacherID="teacherID"></TeachOtoScheduleDetail>
      </TabPane>
    </Tabs>
  </div>
</template>

<script>
import CourseList from '../teach/CourseList'
import TeachOtoScheduleDetail from '../teach/TeachOtoScheduleDetail'

export default {
  name: 'teacher-detail',
  components: {
    CourseList,
    TeachOtoScheduleDetail
  },
  data() {
    return {
      teacherData: {
        avatar: ''
      },
      teacherID: this.$route.query.id
    }
  },
  created() {
    this.requestDetail()
  },
  methods: {
    // request
    requestDetail() {
      this.$http.get('/api/teacher/' + this.teacherID).then(data => {
        this.teacherData = data
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.teacher-detail {
  .info-box {
    border: 1px solid #eee;
    padding: 10px;
    display: flex;
    align-items: flex-start;
    justify-content: flex-start;
    img {
      width: 100px;
      height: 100px;
      margin: 10px 30px;
    }
    .info-box-left {
      .teacher-name {
        margin-top: 15px;
        font-size: 16px;
      }
      .teacher-level {
        font-size: 14px;
        color: red;
      }
      .teacher-introduction {
        margin-top: 10px;
        font-size: 13px;
        width: 1050px;
        word-wrap: break-word;
      }
    }
  }
  .tabs {
    margin-top: 15px;
    overflow: visible;
    .item-width {
      width: 200px;
    }
    .btn-group {
      float: left;
    }
    .page {
      float: right;
    }
  }
}
</style>
